import { render, staticRenderFns } from "./MollieNoProfileModal.vue?vue&type=template&id=78be5898&scoped=true&"
import script from "./MollieNoProfileModal.vue?vue&type=script&lang=js&"
export * from "./MollieNoProfileModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78be5898",
  null
  
)

export default component.exports